import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <div
        style={{
          width: "100%",
          paddingTop: "2em",
          paddingBottom: "2em",
          backgroundColor: "#337ab7",
          color: "white",
          textAlign: "center"
        }}
      >
        Swift Management AG, Basel, Switzerland &copy; 2018{" "}
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js